/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WriteOffDto = {
    amount: number;
    commissionTarget: WriteOffDto.commissionTarget;
};
export namespace WriteOffDto {
    export enum commissionTarget {
        BUSINESS = 'BUSINESS',
        BOTH = 'BOTH',
    }
}

